import React, {useEffect, useState} from 'react';
import {getAllQuoteTemplates} from "../../services/quote-template-data-service";
import QuoteTemplateImage from "./quote-template-image";

const PreviewQuoteTemplates = ({quoteId, applySelectedStyle}) => {
    const [showModal, setShowModal] = useState(false);
    const [selectedQuoteTemplate, setSelectedQuoteTemplate] = useState(null);
    const [quoteTemplatesList, setQuoteTemplatesList] = useState(null);

    useEffect(() => {
        if (showModal) {
            getQuoteTemplatesById(quoteId);
        }
    }, [showModal]);

    const getQuoteTemplatesById = async (quoteId) => {
        getAllQuoteTemplates(quoteId)
            .then(response => {
                setQuoteTemplatesList(response);
            });
    }

    const handleApplySelectedStyle = () => {
        applySelectedStyle(selectedQuoteTemplate);
        setShowModal(false);
    }

    const handleCancelAction = () => {
        setShowModal(false);
    }

    return (
        <>
            <div className="flex items-center justify-center">
                <button
                    className="button-outline-small mr-2"
                    onClick={() => setShowModal(true)}>
                    <span>Apply Templates</span>
                </button>
            </div>
            {showModal ? (
                <>
                    <div
                        className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                        <div className="relative w-auto my-6 mx-auto max-w-7xl">
                            {/*content*/}
                            <div
                                className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                                {/*header*/}
                                <div
                                    className="flex justify-center px-5 pt-6 rounded-t">
                                    <h3 className="text-3xl font-bold">
                                        Select & Apply Template Style
                                    </h3>
                                </div>
                                {/*body*/}
                                <div
                                    className="relative p-6">
                                    <div
                                        className="justify-center preview-font-family-section-container overflow-y-scroll border border-gray-400 bg-gray-100 rounded">
                                        <div className="flex flex-wrap m-2">
                                            {quoteTemplatesList?.map((quoteTemplate, index) => {
                                                return <React.Fragment key={`quoteTemplate-${index}`}>
                                                    <QuoteTemplateImage
                                                        quoteTemplate={quoteTemplate}
                                                        selectedQuoteTemplate={selectedQuoteTemplate}
                                                        setSelectedQuoteTemplate={setSelectedQuoteTemplate}/>
                                                </React.Fragment>
                                            })}
                                        </div>
                                    </div>
                                </div>
                                {/*footer*/}
                                <div
                                    className="flex items-center justify-center px-6 pb-6 rounded-b">
                                    <button
                                        className="text-gray-500 border border-gray-500 h-10 rounded px-4 outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={handleCancelAction}>
                                        Cancel
                                    </button>
                                    <button
                                        className="ml-2 bg-green-500 text-white hover:border hover:border-gray-400 hover:bg-green-200 hover:text-green-800 h-10 rounded px-4 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={handleApplySelectedStyle}>
                                        Apply Selected Style
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </>
            ) : null}
        </>
    );
}

export default PreviewQuoteTemplates
